export function news(bp, $) {
    let w = window.innerWidth;
    const news = {
        // ブログアイテム画像位置
        changeHtml(w) {
            const $newsItem = $('#js-news__row').find('.news-item');
            $newsItem.each(function() {
                const $ele      = $(this).find('.news-item__img');
                const $targetPC = $(this).find('.news-item__body');
                const $targetSP = $(this).find('.news-item__ttl');

                if(bp < w) {
                    if($(this).find('.news__sp-wrapper').length) {
                        $ele.unwrap();
                    }
                    $($ele).insertBefore($targetPC);
                } else {
                    $($ele).insertBefore($targetSP);
                    if($(this).find('.news__sp-wrapper').length == 0) {
                        $(this).find('.news-item__img, .news-item__ttl').wrapAll('<div class="news__sp-wrapper"></div>');
                    }
                }
            });
        }
    };


    news.changeHtml(w);
    $(window).resize(function() {
        w = window.innerWidth;
        news.changeHtml(w);
    });
}
